import React from 'react'
import './style.scss'
import { Button, Card } from '../ui'
import { IconArrowUp, IconCaret } from '../../assets/icons'
import Canvas from '../Canvas'

export default function ProjectDetails(props) {
  return (
    <div className="sw-pd">
      <div className="sw-pad">
        <div>
          <Button type="link" onClick={() => {props.history.goBack()}}><IconCaret/><span>Back</span></Button>
        </div>
        <br/><br/><br/>
        <div className="sw-pd_head">
          <div><Card className="sw-pd_head-img" style={{background: `url(https://images.unsplash.com/photo-1557853197-aefb550b6fdc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=120&q=80)`}}/></div>
          <div className="sw-pd_head-title">
            <h2><b>Escape through space</b></h2>
            <br/>
            <div>
              <span><p><b>24/04/2020</b></p></span><br/>
              <Button type="success--invert">
                <IconArrowUp/><span>Download</span>
              </Button>
            </div>
          </div>
        </div>
        <div className="sw-pd_body">
          <section>
            <h3><b>About</b></h3><br/>
            <p>
              It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal.
            </p>
          </section>
          <section>
            <h3><b>Description</b></h3><br/>
            <p>
              It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
            </p>
          </section>        
        </div>
      </div>
      <div className="sw-pd_canvas">
        <Canvas/>
      </div>
    </div>
  )
}
